import { getErrorMessage } from '../error'
import { isString } from '../is'

export const safeJSONParse = <T = any>(value: string, fallback: T): T => {
  if (!isString(value)) return fallback
  try {
    return JSON.parse(value)
  } catch (e) {
    return fallback
  }
}

export const jsonStringify = (it: any, indent: number = 0, maxDepth: number = 0): string => {
  const ensureProps = (value: any): any => {
    const throwsMessage = (e: any) => {
      const msg = getErrorMessage(e)
      return `[Error: ${msg}]`
    }

    const getProp = (it: any, key: string) => {
      const hasProp = Object.prototype.hasOwnProperty
      if (hasProp.call(it, key)) {
        try {
          return it[key]
        } catch (e) {
          return throwsMessage(e)
        }
      }
      return it[key]
    }

    const seen: any[] = []

    const hasSeen = (it: any) => seen.includes(it)

    const visit = (it: any, depth: number = 0): any => {
      if (!it || typeof it !== 'object') return it
      if (hasSeen(it) && depth >= maxDepth) return '[Circular]'
      seen.push(it)

      if (typeof it.toJSON === 'function') {
        try {
          const result = visit(it.toJSON(), depth + 1)
          seen.pop()
          return result
        } catch (e) {
          return throwsMessage(e)
        }
      }

      if (Array.isArray(it)) {
        const result = it.map((k) => visit(k, depth + 1))
        seen.pop()
        return result
      }

      const result = Object.keys(it).reduce(function (result: any, prop) {
        result[prop] = visit(getProp(it, prop), depth + 1)
        return result
      }, {})
      seen.pop()
      return result
    }

    return visit(value)
  }

  return JSON.stringify(ensureProps(it), undefined, indent)
}
